import axios from 'axios';
import {
  visaOptions
} from '@/config';

export default {
  getHolidays({
    state,
    commit
  }) {

    return axios
      .get(state.data.myBookings.dataUrl)
      .then(response => {
        commit('setLoading', false);
        commit('setHolidays', response.data.holidays);

        if (!response.data.isAuthenticated) {
          document.location.href = '/login';
          return;
        }
      });

  },

  getBooking({
    state,
    commit,
    rootState
  }) {
    return axios
      .get(state.data.overviewContent.bookingDataUrl, {
        params: {
          bookingReference: rootState.route.params.id
        }
      })
      .then(response => {
        commit('setBooking', response.data);
      });

  },

  getDepartureDetails({
    state,
    commit
  }) {

    return axios
      .get(state.data.flights.dataUrl, {
        params: {
          departureId: state.booking.departureId,
          filo: state.booking.filo,
          transportCode: state.booking.departureTransportCode
        }
      })
      .then(response => {
        commit('setDepartureDetails', response.data);
      })
      .catch(error => {
        console.error(error);
        return Promise.resolve();
      });
  },

  getPayment({
    state,
    commit,
    rootState
  }) {

    return axios
      .get(state.data.paymentsContent.paymentsDataUrl, {
        params: {
          bookingReference: rootState.route.params.id
        }
      })
      .then(response => {
        commit('setPayment', response.data);
      });
  },

  getExcursionData({
    state,
    commit,
    rootState
  }) {
    return axios
      .get(state.data.overviewContent.bookedExcursionsUrl, {
        params: {
          bookingReference: rootState.route.params.id
        }
      })
      .then(response => {
        commit('setExcursionData', response.data);
      });
  },

  excursions({
    state,
    commit,
    getters
  }) {
    return axios
      .post(state.data.bookingExcursions.submitUrl, getters.excursions)
      .then(response => {
        console.log(response.data);
      });
  },

  getVisas({
    state,
    commit,
    rootState
  }) {
    return axios
      .get(state.data.visa.dataUrl, {
        params: {
          departureId: state.booking.departureId,
          filo: state.booking.filo,
          bookingReference: rootState.route.params.id
        }
      })
      .then(response => {
        commit('setVisas', response.data);
      })
      .catch(() => {
        commit('setError', true);
      });
  },

  getUserDetails({
    state,
    commit
  }) {

    return axios
      .get(state.data.manageMyDetailsContent.dataUrl)
      .then(response => {
        commit('setUserDetails', response.data);
      })
      .catch(error => {
        console.error(error);
      });
  },

  updatePassenger({
    state,
    commit,
    dispatch,
    rootGetters,
    rootState
  }, passenger) {
    commit('setLoading', true);

    const formData = rootGetters.formDataFlat(passenger);

    // Convert visaIds object into flat array
    if (formData.visaIds) {
      const visaIds = [];
      for (const visaId in formData.visaIds) {
        if (formData.visaIds[visaId] === visaOptions.required) {
          visaIds.push(visaId);
        }
      }
      formData.visaIds = visaIds;
    }

    return axios
      .post(state.data.passengerDetailsContent.submitUrl, {
        ...passenger,
        emergencyContacts: passenger.emergencyContacts.filter(kin => kin.firstName),
        ...formData,
        bookingReference: rootState.route.params.id
      })
      .catch(() => {
        commit('setLoading', false);
      })
      .finally(() => {
        dispatch('getBooking').then(() => {
          commit('setLoading', false);
        });
      });
  },

  updatePassengerKin({
    state,
    commit,
    dispatch,
    rootGetters,
    rootState
  }, data) {
    commit('setLoading', true);

    const formData = rootGetters.formDataFlat(data.kin);

    // Add address into suitable format for API
    if (formData.address) {
      formData.address.addressLines = Object.keys(formData.address.addressLines).map(k => formData.address.addressLines[k]);
    }

    data.passenger.emergencyContacts[data.kinIndex] = {
      ...data.passenger.emergencyContacts[data.kinIndex],
      ...formData
    };

    return axios
      .post(state.data.passengerDetailsContent.submitUrl, {
        ...data.passenger,
        bookingReference: rootState.route.params.id
      })
      .catch(() => {
        commit('setLoading', false);
      })
      .finally(() => {
        dispatch('getBooking').then(() => {
          commit('setLoading', false);
        });
      });
  },

  paymentStatus({
    state,
    commit,
    dispatch
  }, data) {
    commit('setLoading', true);

    return axios
      .get(state.data.paymentsContent.paymentStatusUrl, {
        params: {
          transactionId: data.transactionId
        }
      })
      .then(response => {
        // keep polling the status endpoint until its success/failure
        if (response.data.status === 'pending') {
          dispatch('paymentStatus');
        }
        // set errors from the response
        else if (response.data.status === 'error') {
          commit('setPaymentError', true);
          commit('setLoading', false);
        }
        // hit the confirm booking url
        else {
          dispatch('confirmPayment', data);
        }
      })
      .catch(() => {
        commit('setError', true);
        commit('setPaymentError', true);
      });
  },

  confirmPayment({
    state,
    commit,
    dispatch,
    rootState
  }, data) {
    commit('setLoading', true);

    return axios
      .post(state.data.paymentsContent.confirmPaymentUrl, {
        amount: state.paymentAmount,
        bookingReference: rootState.route.params.id,
        transactionId: data.transactionId,
        cardTypeId: state.cardTypeId
      })
      .then(response => {

        // set errors from the response
        if (!response.data.success) {
          commit('setPaymentError', true);
          commit('setLoading', false);

        } else {
          // set payment success data
          commit('setPaymentSuccess', response.data);

          // reset previous payment data
          commit('setPaymentFrame', null);
          commit('setPaymentAmount', null);
          commit('setCardTypeId', null);

          // get new payment data to update the values etc...
          dispatch('getPayment').then(() => {
            // we've finished so we can show the form again
            commit('setLoading', false);
          });
        }
      })
      .catch(error => {
        commit('setError', true);
      });
  },
}